import React, { ReactNode } from 'react'
import { ReorderResponse } from '../../services/reOrder/model'

export const ReorderProduct = React.createContext<
  | {
      reorderProduct?: ReorderResponse['result_data']
      setReorderProduct: React.Dispatch<React.SetStateAction<ReorderResponse['result_data'] | undefined>>
    }
  | undefined
>(undefined)

const RedirectToProduct = ({ children }: { children: ReactNode }) => {
  const [reorderProduct, setReorderProduct] = React.useState<ReorderResponse['result_data'] | undefined>(undefined)
  return <ReorderProduct.Provider value={{ reorderProduct, setReorderProduct }}>{children}</ReorderProduct.Provider>
}
export default RedirectToProduct
